module.exports = __webpack_public_path__ + "img/map.cdcaa306.png";